import $apiJSON from '../http/apiJSON'

// ========== ARCHIVE UNIVERSITY SERVICES ==========

export const getUniversityFunds = async () => {
  try {
    const response = await $apiJSON.get('archive/university/funds/')
    return response.data
  } catch (error) {
    console.error('Ошибка при получении фондов:', error)
    throw error
  }
}

export const getUniversityInventories = async () => {
  try {
    const response = await $apiJSON.get('archive/university/inventories/')
    return response.data
  } catch (error) {
    console.error('Ошибка при получении описей:', error)
    throw error
  }
}

export const createUniversityInventory = async (data) => {
  try {
    const response = await $apiJSON.post('archive/university/inventories/', data)
    return response.data
  } catch (error) {
    console.error('Ошибка при создании описи:', error)
    throw error
  }
}

export const createUniversityFund = async (data) => {
  try {
    const response = await $apiJSON.post('archive/university/funds/', data)
    return response.data
  } catch (error) {
    console.error('Ошибка при создании фонда:', error)
    throw error
  }
}

export const updateUniversityFund = async (fundId, data) => {
  try {
    const response = await $apiJSON.patch(`archive/university/funds/${fundId}/`, data)
    return response.data
  } catch (error) {
    console.error('Ошибка при обновлении фонда:', error)
    throw error
  }
}

export const deleteUniversityFund = async (fundId) => {
  try {
    await $apiJSON.delete(`archive/university/funds/${fundId}/`)
  } catch (error) {
    console.error('Ошибка при удалении фонда:', error)
    throw error
  }
}

// University Cases
export const getUniversityCases = async () => {
  try {
    const response = await $apiJSON.get('archive/university/cases/')
    return response.data
  } catch (error) {
    console.error('Ошибка при получении дел:', error)
    throw error
  }
}

export const createUniversityCase = async (data) => {
  try {
    const response = await $apiJSON.post('archive/university/cases/', data)
    return response.data
  } catch (error) {
    console.error('Ошибка при создании дела:', error)
    throw error
  }
}

export const updateUniversityCase = async (caseId, data) => {
  try {
    const response = await $apiJSON.patch(`archive/university/cases/${caseId}/`, data)
    return response.data
  } catch (error) {
    console.error('Ошибка при обновлении дела:', error)
    throw error
  }
}

export const deleteUniversityCase = async (caseId) => {
  try {
    await $apiJSON.delete(`archive/university/cases/${caseId}/`)
  } catch (error) {
    console.error('Ошибка при удалении дела:', error)
    throw error
  }
}

// University Documents
export const getUniversityDocuments = async () => {
  try {
    const response = await $apiJSON.get('archive/university/documents/')
    return response.data
  } catch (error) {
    console.error('Ошибка при получении документов:', error)
    throw error
  }
}

export const createUniversityDocument = async (data, file = null) => {
  try {
    if (file) {
      // Если есть файл, используем FormData
      const formData = new FormData()
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key])
        }
      })
      formData.append('file', file)
      const response = await $apiJSON.post('archive/university/documents/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return response.data
    } else {
      // Без файла используем JSON
      const response = await $apiJSON.post('archive/university/documents/', data)
      return response.data
    }
  } catch (error) {
    console.error('Ошибка при создании документа:', error)
    throw error
  }
}

export const updateUniversityDocument = async (documentId, data) => {
  try {
    const response = await $apiJSON.patch(`archive/university/documents/${documentId}/`, data)
    return response.data
  } catch (error) {
    console.error('Ошибка при обновлении документа:', error)
    throw error
  }
}

export const deleteUniversityDocument = async (documentId) => {
  try {
    await $apiJSON.delete(`archive/university/documents/${documentId}/`)
  } catch (error) {
    console.error('Ошибка при удалении документа:', error)
    throw error
  }
}

export const uploadUniversityDocumentFile = async (documentId, file) => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    const response = await $apiJSON.post(
      `archive/university/documents/${documentId}/upload_file/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return response.data
  } catch (error) {
    console.error('Ошибка при загрузке файла документа университета:', error)
    throw error
  }
}

// ========== ARCHIVE STUDENT SERVICES ==========

export const registerStudent = async (data) => {
  try {
    const response = await $apiJSON.post('archive/students/cases/register_student/', data)
    return response.data
  } catch (error) {
    console.error('Ошибка при регистрации студента:', error)
    throw error
  }
}

export const createStudentCase = async (data) => {
  try {
    const response = await $apiJSON.post('archive/students/cases/', data)
    return response.data
  } catch (error) {
    console.error('Ошибка при создании личного дела студента:', error)
    throw error
  }
}

export const digitizeStudentCase = async (caseId) => {
  try {
    const response = await $apiJSON.post(`archive/students/cases/${caseId}/digitize/`)
    return response.data
  } catch (error) {
    console.error('Ошибка при оцифровке личного дела студента:', error)
    throw error
  }
}

export const getStudentCases = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await $apiJSON.get(`archive/students/cases/?${params}`)
    return response.data
  } catch (error) {
    console.error('Ошибка при получении личных дел студентов:', error)
    throw error
  }
}

export const getStudentCaseDetail = async (caseId) => {
  try {
    const response = await $apiJSON.get(`archive/students/cases/${caseId}/`)
    return response.data
  } catch (error) {
    console.error('Ошибка при получении деталей личного дела:', error)
    throw error
  }
}

export const createStudentDocument = async (data, file = null) => {
  try {
    if (file) {
      // Если есть файл, используем FormData
      const formData = new FormData()
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key])
        }
      })
      formData.append('file', file)
      const response = await $apiJSON.post('archive/students/documents/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return response.data
    } else {
      // Без файла используем JSON
      const response = await $apiJSON.post('archive/students/documents/', data)
      return response.data
    }
  } catch (error) {
    console.error('Ошибка при создании документа студента:', error)
    throw error
  }
}

export const updateStudentCase = async (caseId, data) => {
  try {
    const response = await $apiJSON.patch(`archive/students/cases/${caseId}/`, data)
    return response.data
  } catch (error) {
    console.error('Ошибка при обновлении личного дела студента:', error)
    throw error
  }
}

export const deleteStudentCase = async (caseId) => {
  try {
    await $apiJSON.delete(`archive/students/cases/${caseId}/`)
  } catch (error) {
    console.error('Ошибка при удалении личного дела студента:', error)
    throw error
  }
}

export const uploadStudentDocumentFile = async (documentId, file) => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    const response = await $apiJSON.post(
      `archive/students/documents/${documentId}/upload_file/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return response.data
  } catch (error) {
    console.error('Ошибка при загрузке файла документа студента:', error)
    throw error
  }
}

// ========== ARCHIVE EMPLOYEE SERVICES ==========

export const getEmployees = async (filters = {}) => {
  try {
    // Используем правильный endpoint для получения всех сотрудников
    const params = new URLSearchParams({ user_type: 'E', ...filters }).toString()
    const response = await $apiJSON.get(`employees/all-employees/?${params}`)
    return response.data
  } catch (error) {
    console.error('Ошибка при получении списка сотрудников:', error)
    // Возвращаем пустой массив в случае ошибки
    return []
  }
}

export const createEmployeeCase = async (data) => {
  try {
    const response = await $apiJSON.post('archive/employees/cases/create_case_for_employee/', data)
    return response.data
  } catch (error) {
    console.error('Ошибка при создании личного дела сотрудника:', error)
    throw error
  }
}

export const getEmployeeCases = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await $apiJSON.get(`archive/employees/cases/?${params}`)
    return response.data
  } catch (error) {
    console.error('Ошибка при получении личных дел сотрудников:', error)
    throw error
  }
}

export const getEmployeeCaseDetail = async (caseId) => {
  try {
    const response = await $apiJSON.get(`archive/employees/cases/${caseId}/`)
    return response.data
  } catch (error) {
    console.error('Ошибка при получении деталей личного дела сотрудника:', error)
    throw error
  }
}

export const createEmployeeDocument = async (data, file = null) => {
  try {
    if (file) {
      // Если есть файл, используем FormData
      const formData = new FormData()
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key])
        }
      })
      formData.append('file', file)
      const response = await $apiJSON.post('archive/employees/documents/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      return response.data
    } else {
      // Без файла используем JSON
      const response = await $apiJSON.post('archive/employees/documents/', data)
      return response.data
    }
  } catch (error) {
    console.error('Ошибка при создании документа сотрудника:', error)
    throw error
  }
}

export const updateEmployeeCase = async (caseId, data) => {
  try {
    const response = await $apiJSON.patch(`archive/employees/cases/${caseId}/`, data)
    return response.data
  } catch (error) {
    console.error('Ошибка при обновлении личного дела сотрудника:', error)
    throw error
  }
}

export const deleteEmployeeCase = async (caseId) => {
  try {
    await $apiJSON.delete(`archive/employees/cases/${caseId}/`)
  } catch (error) {
    console.error('Ошибка при удалении личного дела сотрудника:', error)
    throw error
  }
}

export const digitizeEmployeeCase = async (caseId) => {
  try {
    const response = await $apiJSON.post(`archive/employees/cases/${caseId}/digitize/`)
    return response.data
  } catch (error) {
    console.error('Ошибка при оцифровке личного дела сотрудника:', error)
    throw error
  }
}

export const uploadEmployeeDocumentFile = async (documentId, file) => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    const response = await $apiJSON.post(
      `archive/employees/documents/${documentId}/upload_file/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    return response.data
  } catch (error) {
    console.error('Ошибка при загрузке файла документа сотрудника:', error)
    throw error
  }
}

export const updateStudentDocument = async (documentId, data) => {
  try {
    const response = await $apiJSON.patch(`archive/students/documents/${documentId}/`, data)
    return response.data
  } catch (error) {
    console.error('Ошибка при обновлении документа студента:', error)
    throw error
  }
}

export const deleteStudentDocument = async (documentId) => {
  try {
    await $apiJSON.delete(`archive/students/documents/${documentId}/`)
  } catch (error) {
    console.error('Ошибка при удалении документа студента:', error)
    throw error
  }
}

export const updateEmployeeDocument = async (documentId, data) => {
  try {
    const response = await $apiJSON.patch(`archive/employees/documents/${documentId}/`, data)
    return response.data
  } catch (error) {
    console.error('Ошибка при обновлении документа сотрудника:', error)
    throw error
  }
}

export const deleteEmployeeDocument = async (documentId) => {
  try {
    await $apiJSON.delete(`archive/employees/documents/${documentId}/`)
  } catch (error) {
    console.error('Ошибка при удалении документа сотрудника:', error)
    throw error
  }
}

// ========== ACTIVITY LOG SERVICES ==========

export const getActivityLog = async (archiveType = null) => {
  try {
    let url = 'archive/activity-log/'
    if (archiveType) {
      url += `?archive_type=${archiveType}`
    }
    const response = await $apiJSON.get(url)
    return response.data
  } catch (error) {
    console.error('Ошибка при получении журнала действий:', error)
    throw error
  }
}
